import { createContext, useContext } from "react";

const ChartGridContext = createContext({
    showModalSurveyQuestion: undefined,
    togglePeersOnly: undefined,
    updateChartResults: undefined
});

export const useChartGridContext = () => {
    const context = useContext(ChartGridContext);
    if (!context) {
        throw new Error("useChartContext must be used within a ChartGridContext.Provider");
    }
    return context;
};

export default ChartGridContext;